import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Button, Card, Grid, Stack, Typography, Fade, IconButton, Popover, DialogActions, Pagination, Dialog, DialogTitle, DialogContent, Box } from "@mui/material";
import Avatar from "ui-component/extended/Avatar";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";
import { Delete } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import { IconEye } from "@tabler/icons";
// import 'react-toastify/dist/ReactToastify.css';

const CommentList = ({
  comment,
  postId,
  setPosts,
  openComment,
  getCommentList,
  userId,
  type = "forAlumni",
}) => {
  const theme = useTheme();
  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();
  const [loading, setLoading] = useState(false);

  const AlumniuserId = localStorage.getItem('userId')

  const [commentlikeList, setCommentLikeList] = useState([])
  const [likeAnchorEl, setLikeAnchorEl] = useState(null);

  const [likeDialogOpen, setLikeDialogOpen] = useState(false);
  const [commentLikePage, setCommentLikePage] = useState(0);
  const [totalCommentLikes, setTotalCommentLikes] = useState(0);
  const pageSize = 10;


  const handleLikeClick = () => {
    setLikeDialogOpen(true);
    getCommentLikes(comment?.id, 0); // Load first page
  };

  const handleLikeDialogClose = () => {
    setLikeDialogOpen(false);
  };
  const openLikeList = Boolean(likeAnchorEl);



  const handleCommentLikes = async (postId, commentId, like) => {
    try {
      setLoading(true); // Start loading
      const response = await axios.get(
        `/v1/posts/like/comment?like=${like}&postId=${postId}&commentId=${commentId}&alumniId=${localStorage.getItem(
          "alumniId"
        )}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      getCommentList(postId);
      // setPosts(response?.data?.data);
      generateTimeStamp();
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getCommentLikes = async (commentId, page = 0) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `/v1/posts/like/comment-list?commentId=${commentId}&pageSize=${pageSize}&pageNumber=${page}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      setCommentLikeList(response?.data?.data?.content || []);
      setTotalCommentLikes(response?.data?.data?.totalElements || 0);
      setCommentLikePage(page);
      generateTimeStamp();
    } catch (error) {
      console.error("Failed to fetch comment likes:", error);
    } finally {
      setLoading(false);
    }
  };


  let deleteTimeout = null;

  const deleteCommentAfterDelay = (postId, commentId) => {
    deleteTimeout = setTimeout(async () => {
      try {
        const response = await axios.delete(
          `/v1/posts/delete/comment/${commentId}`,
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
              "Content-Type": "application/json",
              requestId: RequestId(
                Math.floor(1000 + Math.random() * 9999),
                Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
              ),
            },
          }
        );
        getCommentList(postId);
        setPosts(response?.data?.data);
        generateTimeStamp();
      } catch (error) {
        console.error("Failed to delete comment:", error);
      }
    }, 5000);
  };

  const handleDeletePost = (postId, commentId) => {
    toast.info(
      ({ closeToast }) => (
        <div>
          Comment will be deleted in 5 seconds.
          <Button
            onClick={() => {
              clearTimeout(deleteTimeout);
              closeToast();
              toast.success("Delete canceled.");
            }}
            color="secondary"
            size="small"
            style={{ marginLeft: 10 }}
          >
            Undo
          </Button>
        </div>
      ),
      {
        position: "bottom-right",
        autoClose: 5000,
        // closeOnClick: false,
        // pauseOnHover: true,
      }
    );

    deleteCommentAfterDelay(postId, commentId);
  };

  const handleCommentLikePageChange = (event, newPage) => {
    getCommentLikes(comment?.id, newPage - 1); // MUI is 1-based, backend might be 0-based
  };

  useEffect(() => {
    generateTimeStamp();
  }, []);

  return (
    <>
      {openComment && (
        <Grid container spacing={2}>
          <Fade in={!!Object.keys(comment).length} timeout={400}>
            <Grid item xs={12}>
              <Card
                sx={{
                  background:
                    theme.palette.mode === "dark"
                      ? theme.palette.dark.main
                      : theme.palette.grey[50],
                  padding: "16px 16px 8px",
                  mt: 1.25,
                  transition: "border-color 0.3s ease",
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid
                      container
                      wrap="nowrap"
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>
                        <Avatar
                          sx={{ width: 24, height: 24 }}
                          size="sm"
                          alt="User 1"
                          src={`data:image/*;base64, ${comment?.alumniMemberMini?.avatar?.data}`}
                        />
                      </Grid>
                      <Grid item xs zeroMinWidth>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item>
                            <Typography
                              align="left"
                              variant="h5"
                              component="div"
                            >
                              {comment.alumniMemberMini
                                ? comment.alumniMemberMini?.name
                                : comment?.postCommentByName}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography align="left" variant="caption">
                              <FiberManualRecordIcon
                                sx={{
                                  width: "10px",
                                  height: "10px",
                                  opacity: 0.5,
                                  m: "0 5px",
                                }}
                              />{" "}
                              {comment.createdAt}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ "&.MuiGrid-root": { pt: 1.5 } }}>
                    <Typography align="left" variant="body2">
                      {comment?.comment}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        color:
                          theme.palette.mode === "dark"
                            ? "grey.700"
                            : "grey.800",
                      }}
                    >
                      {/* {type !== "FromAdmin" && ( */}
                      <Button
                        onClick={() => {
                          getCommentLikes(comment?.id)
                          handleCommentLikes(
                            postId,
                            comment.id,
                            !comment?.commentLikesIds?.includes(
                              localStorage.getItem("userId")
                            )
                          )
                        }
                        }
                        variant="text"
                        color="inherit"
                        size="small"
                        startIcon={
                          <ThumbUpAltTwoToneIcon
                            color={comment.likes ? "secondary" : "inherit"}
                          />
                        }
                      >
                        <Typography>{comment?.likes} likes</Typography>

                      </Button>
                      <IconEye onClick={handleLikeClick} />
                      {/* )} */}
                      {AlumniuserId === userId && (
                        <>
                          <IconButton size="small"
                            onClick={() =>
                              handleDeletePost(
                                postId,
                                comment.id
                              )
                            }
                            color="error"
                          >
                            <Delete sx={{ fontSize: '20px' }} />
                          </IconButton>
                        </>
                      )}

                    </Stack>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Fade>
        </Grid>
      )}
      <Dialog open={likeDialogOpen} onClose={handleLikeDialogClose} fullWidth maxWidth="xs">
        <DialogTitle>Liked by</DialogTitle>
        <DialogContent dividers>
          {loading ? (
            <Typography variant="body2">Loading...</Typography>
          ) : commentlikeList.length > 0 ? (
            <Stack spacing={1.5}>
              {commentlikeList.map((user, idx) => (
                <Box
                  key={idx}
                  display="flex"
                  alignItems="center"
                  gap={1.5}
                  sx={{ borderBottom: '1px solid #eee', pb: 1 }}
                >
                  <Avatar
                    alt={user?.alumniMemberMini?.name || user?.likedByName}
                    src={`data:image/*;base64, ${user?.alumniMemberMini?.avatar?.data || ''}`}
                    sx={{ width: 36, height: 36 }}
                  />
                  <Typography variant="body1" noWrap>
                    {user?.alumniMemberMini?.name || user?.likedByName}
                  </Typography>
                </Box>
              ))}
            </Stack>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No likes yet.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Pagination
            count={Math.ceil(totalCommentLikes / pageSize)}
            page={commentLikePage + 1}
            onChange={handleCommentLikePageChange}
            color="primary"
            size="small"
          />
        </DialogActions>
      </Dialog>



      <ToastContainer />
    </>
  );
};

CommentList.propTypes = {
  comment: PropTypes.object,
  postId: PropTypes.string,
  user: PropTypes.object,
  commentAdd: PropTypes.func,
  handleCommentLikes: PropTypes.func,
  handlePostLikes: PropTypes.func,
  handleReplayLikes: PropTypes.func,
  post: PropTypes.object,
  replyAdd: PropTypes.func,
};

export default CommentList;
